import React, { useEffect } from "react";
import "./OrderPage.css";
import Product_1 from "../../../Assets/Products/Product_1.jpeg";
import Product_2 from "../../../Assets/Products/Product_2.png";
import Product_3 from "../../../Assets/Products/Product_3.png";
import Product_4 from "../../../Assets/Products/Product_4.png";
import Footer from "../../Footer/Footer";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../App/store";
import { fetchOrderTrackingData } from "../../../Slice/Order.Slice";
import { getStoredAuth } from "../../../StoreData/authUser";
import { getOrderTracking } from "../../../Action/order.Action";

interface Product {
  id: string;
  name: string;
  quantity: number;
  price: string;
  imageUrl: string;
}

interface Order {
  id: string;
  date: string;
  status: "Delivered" | "Processing" | "Cancelled";
  total: string;
  products: Product[];
}

const orders: Order[] = [
  {
    id: "ORD-1001",
    date: "2025-07-10",
    status: "Delivered",
    total: "$129.99",
    products: [
      {
        id: "P-001",
        name: "Blue Denim Jacket",
        quantity: 1,
        price: "$59.99",
        imageUrl:
          Product_1,
      },
      {
        id: "P-002",
        name: "White Sneakers",
        quantity: 2,
        price: "$35.00",
        imageUrl:
          Product_2,
      },
    ],
  },
  {
    id: "ORD-1002",
    date: "2025-07-08",
    status: "Processing",
    total: "$89.49",
    products: [
      {
        id: "P-003",
        name: "Black T-Shirt",
        quantity: 2,
        price: "$45.00",
        imageUrl:
          Product_3,
      },
    ],
  },
  {
    id: "ORD-1003",
    date: "2025-07-05",
    status: "Cancelled",
    total: "$49.00",
    products: [
      {
        id: "P-004",
        name: "Red Lipstick",
        quantity: 1,
        price: "$49.00",
        imageUrl:
          Product_4,
      },
    ],
  },
];

const OrdersPage: React.FC = () => {

  const dispatch = useDispatch<AppDispatch>();

  const { orderTrackingData } = useSelector((state: any) => state.orders)

  const navigate = useNavigate()


  useEffect(() => {
    const storedAuth = getStoredAuth();

    if (!storedAuth) {
      navigate('/');
      return;
    }

    try {
      const parsed = JSON.parse(storedAuth);
      const user = parsed[0];

      if (!user || !user.mid) {
        navigate('/');
      } else {
        dispatch(getOrderTracking(user.mid));
      }
    } catch (error) {
      console.error("Failed to parse auth data:", error);
      navigate('/');
    }
  }, [dispatch, navigate]);



  const scrollToTop = (): void => {
    window.scrollTo({
      top: 500,
      behavior: "smooth",
    });
  };



  const handleOnNavigation = (each: any) => {

    
    navigate(`/orderTracking?orderid=${each?.items[0].OrderNo}`, { state: each })
  }

 
  return (
    <div className="orders-container">
      <header className="orders-header">
        <button className="back-btn" onClick={() => window.history.back()}>
          ← Back to Shop
        </button>

      </header>

      <main className="orders-main">
        <h2>My Orders</h2>

        {/* Group order items by OrderNo */}
        {Object.entries(
          orderTrackingData.reduce((acc: any, item: any) => {
            if (!acc[item.OrderNo]) {
              acc[item.OrderNo] = {
                orderInfo: item, // we use this for date, status, etc.
                items: [],
              };
            }
            acc[item.OrderNo].items.push(item);
            return acc;
          }, {})
        ).map(([orderNo, order]: any) => (
          <div className="order-card" key={orderNo}>
            <div className="order-summary">
              <h3>Order #{order.orderInfo.OrderNo}</h3>
              <p>Date: {order.orderInfo.OrderDate?.split("T")[0]}</p>
              <p className={`status ${order.orderInfo.OrderMode?.toLowerCase()}`}>
                Status: {order.orderInfo.OrderMode}
              </p>
              <p>Total: ₹{order.orderInfo.Netorderamount}</p>
            </div>

            <div className="products-list">
              {order.items.map((product: any, idx: number) => (
                <div className="product-row" key={idx}>
                  <div className="product-details">
                    <p className="product-name">{product.itemname}</p>
                    <p>Quantity: {product.ItemQty}</p>
                    <p>Price: ₹{product.ItemSellingprice}</p>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="details-btn"
              onClick={() => handleOnNavigation(order)}
            >
              Order Details
            </button>
          </div>
        ))}
      </main>


      <Footer />
    </div>
  );
};

export default OrdersPage;
